module.exports = __webpack_public_path__ + "img/50-50.72ffa66b.svg";